// Globals
import { FC } from 'react';
import { useTranslation } from 'react-i18next';

// Components
import { Button } from '@/ui';
import { StyledButtons, StyledErrorRow, StyledErrorsList, StyledStats } from './ImportFaqStatsStyles';

// Models
import { IFaqImportResponse } from '@/models/faqImportExport.model';

type TImportFaqStatsProps = {
  preview: IFaqImportResponse;
  isApplying?: boolean;
  onApply: () => void;
  onChooseDifferentFile: () => void;
};

const ImportFaqStats: FC<TImportFaqStatsProps> = ({ preview, isApplying, onApply, onChooseDifferentFile }) => {
  const { t } = useTranslation();

  return (
    <>
      <StyledStats>
        <p>{t('label_import_total_rows', { count: preview.totalRows })}</p>
        <p>{t('label_import_to_create', { count: preview.toCreate })}</p>
        <p>{t('label_import_to_update', { count: preview.toUpdate })}</p>
        <p>{t('label_import_skipped', { count: preview.skipped })}</p>
        <p>{t('label_import_error_rows', { count: preview.errorRows })}</p>
      </StyledStats>
      {!!preview.errors.length && (
        <StyledErrorsList>
          {preview.errors.map((error) => (
            <StyledErrorRow key={`${error.row}-${error.column}`}>
              {t('label_import_error_row', { row: error.row, column: error.column, message: error.message })}
            </StyledErrorRow>
          ))}
        </StyledErrorsList>
      )}
      <StyledButtons>
        <Button htmlType="button" onClick={onChooseDifferentFile}>
          {t('btn_faqs_import_choose_different_file')}
        </Button>
        <Button type="primary" loading={isApplying} onClick={onApply}>
          {t('btn_faqs_import_apply')}
        </Button>
      </StyledButtons>
    </>
  );
};

export default ImportFaqStats;
